module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/desktop-app-4-433343c9a8c8c609abf912b9577359af.png";